let element = document.getElementById('js-store-locations');
let api = element?.getAttribute('data-stores') ?? '';

var locations = {
	api
};

export default locations;